import axios from "axios";
import {
  store_city_office_utilities,
  get_city_office_utilities,
  update_city_office_utilities,
} from "../../../Api/Api";
import { toast } from "react-toastify";
const _store_city_office_utilities = async (data) => {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };
  const response = await axios({
    method: "POST",
    baseURL: `${store_city_office_utilities}`,
    headers: headers,
    data: data,
  });
  if (response?.status == 200) {
    toast.success(" created Successfully", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
  return response.data;
};

const _get_city_office_utilities = async (data) => {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };
  const response = await axios({
    method: "GET",
    baseURL: `${get_city_office_utilities}/${data.ticket_id}`,
    headers: headers,
    params: {
      type: data.type,
    },
  });
  return response.data;
};

const edit_city_office_utilities = async (data) => {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };
  const response = await axios({
    method: "POST",
    baseURL: `${update_city_office_utilities}`,
    headers: headers,
    data: data,
  });
  if (response?.status == 200) {
    toast.success("modified Successfully", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
  return response.data;
};

const city_office_utilities_Service = {
  _store_city_office_utilities,
  _get_city_office_utilities,
  edit_city_office_utilities,
};
export default city_office_utilities_Service;
